import { render, staticRenderFns } from "./WorkflowDesigner.vue?vue&type=template&id=15ab2630&scoped=true&"
import script from "./WorkflowDesigner.vue?vue&type=script&lang=ts&"
export * from "./WorkflowDesigner.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowDesigner.vue?vue&type=style&index=0&id=15ab2630&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab2630",
  null
  
)

export default component.exports